export class ClaimBO {
    id: string;
    client_FirstName: string;
    client_LastName: string;
    client_MiddleName: string;
    client_DOB: string;
    client_Street: string;
    client_Street2: string;
    client_Apt: string;
    client_City: string;
    client_State: string;
    client_ZipCode: string;
    client_Gender: string;
    employee_FirstName: string;
    employee_MiddleName: string;
    employee_LastName: string;
    auth_InsuranceNumber: string;
    auth_ServiceAgreementNumber: string;
    auth_ICD10Code: string;
    serviceLocationCode: string;
    payerRequired_BillingPayerRequiredId: string;
    payer_ClaimFilingIndicatorCode: string;
    payer_PayorName: string;
    payer_AddressLine1: string;
    payer_AddressLine2: string;
    payer_City: string;
    payer_State: string;
    payer_Zip: string;
    payer_Atypical: boolean;
    payer_InsTypeLovCode: string;
    payer_NPI: string;
    company_Name: string;
    company_AdminFullName: string;
    company_PhoneNumber: string;
    company_Street: string;
    company_City: string;
    company_State: string;
    company_ZipCode: string;
    company_FEIN: string;
    payerCompanyMap_ProviderNumber: string;
    payerCompanyMap_TaxonomyCode: string;
    payerServiceMap_RenderingProviderLovCode: string;
    payerServiceMap_Atypical: boolean;
    payerServiceMap_G2Id: string;
    renderingProvider: string;
    renderingNPI: string;
    claimNote: string;
}

export class ClaimFullBO {
    id: string;
    claimNumber: number;
    totalAmount: number;
    paidAmount: number | null;
    paidDate: string | null;
    balanceDueAmount: number | null;
    resubmissionTypeLid: string;
    resubmissionTypeLidName: string;
    claimStatusLid: string;
    claimStatusLidName: string;
    clientId: string;
    clientName: string;
    client_FirstName: string;
    client_LastName: string;
    client_MiddleName: string;
    client_DOB: string;
    client_Street: string;
    client_Street2: string;
    client_Apt: string;
    client_City: string;
    client_State: string;
    client_ZipCode: string;
    client_GenderLovValue: string;
    clientAuthorizationId: string | null;
    auth_InsuranceNumber: string;
    auth_ServiceAgreementNumber: string;
    auth_ICD10Code: string;
    companyId: string;
    company_Name: string;
    company_AdminFullName: string;
    company_PhoneNumber: string;
    company_Street: string;
    company_City: string;
    company_State: string;
    company_ZipCode: string;
    company_FEIN: string;
    payerId: string;
    payer_ClaimFilingIndicatorCode: string;
    payer_PayorName: string;
    payer_PayorId: string;
    payer_AddressLine1: string;
    payer_AddressLine2: string;
    payer_City: string;
    payer_State: string;
    payer_Zip: string;
    payer_Atypical: boolean;
    payer_InsTypeLovCode: string;
    payer_NPI: string;
    payerCompanyMapId: string | null;
    payerCompanyMap_ProviderNumber: string;
    payerCompanyMap_TaxonomyCode: string;
    serviceId: string | null;
    serviceLocationCode: string;
    payerServiceMapId: string | null;
    payerServiceMap_RenderingProviderLovCode: string;
    payerServiceMap_Atypical: boolean;
    payerServiceMap_G2Id: string;
    employeeId: string | null;
    employee_FirstName: string;
    employee_MiddleName: string;
    employee_LastName: string;
    employee_UMPI: string;
    employee_RNNPI: string;
    payerRequiredIdId: string | null;
    payerRequired_BillingPayerRequiredId: string;
    payerClaimReferenceNumber: string;
    claimNote: string;
    claimServiceLine: ClaimServiceLineBO;
    claimType: string;
   
}

export class ClaimServiceLineBO {
    id: string;
    claimId: string;
    serviceId: string | null;
    serviceCode: string;
    modifier1: string;
    modifier2: string;
    modifier3: string;
    modifier4: string;
    serviceName: string;
    description: string;
    balanceDueAmount: number | null;
    serviceDate: string;
    totalAmount: number;
    paidAmount: number | null;
    paidDate: string | null;
    postedDate: string | null;
    denialAmount: number;
    eDI835ClaimAdjustments: EDI835ClaimAdjustmentBO[];
     payerPaid: number | null = null;
 paidDateFormated: string | null;
 units:string;
}

export class EDI835ClaimAdjustmentBO {
    adjustmentGroupCode: string;
    adjustmentReasonCode: string;
    adjustmentAmount: number | null;
    adjustmentQuantity: string;
}

